import { apps, activeAppStatus } from '@/app/utils/app/app';

const mutations = {
  SET_ACTIVE_APPS(state, value) {
    state.activeApps = value;
  },
  SET_ACTIVE_APP(state, value) {
    state.activeApp = value;
  },
};

const actions = {
  setActiveApp({ commit, state }, appName) {
    commit('SET_ACTIVE_APP', state.activeApps.filter(app => app.appName === appName)[0]);
  },
  setActiveApps: {
    root: true,
    handler({ commit, rootGetters }) {
      const appPermissions = rootGetters['account/getAppPermissions'];
      const appMenuItems = appPermissions.map(permission => ({
        ...apps.filter(app => app.appName === permission.appName)[0],
        permission: permission.permission,
        status: permission.status,
      }));

      // Check can access on account user
      const canAccess = rootGetters['account/getAccountCanAccess'];
      const filteredApps = appMenuItems.filter((app) => {
        const hasAppAccess = canAccess[app.appName];
        return (!!hasAppAccess || activeAppStatus.includes(app.status));
      });
      filteredApps.push(apps[0]); // Home app
      filteredApps.sort((a, b) => a.index - b.index);

      commit('SET_ACTIVE_APPS', filteredApps);
    },
  },
};

const getters = {
  activeApps(state) {
    return state.activeApps;
  },
  activeApp(state) {
    return state.activeApp;
  },
};

const state = {
  activeApp: null,
  activeApps: [],
};

const store = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};

export default store;
